<script>
import UserApi from "../api/UserApi";
import debounce from 'lodash/debounce'

export default {
    props: {
        email: {
            type: String,
            required: false
        },
        lastVerifySend: {
            type: Number,
            required: false,
            default: 0
        }
    },
    data() {
        return {
            showVerbox: false,
            currentTime: 0,
            timer: null
        }
    },
    mounted() {
        const showTimer = Math.floor(Date.now() / 1000) - this.lastVerifySend

        if (showTimer < 60) {
            this.currentTime = 60 - showTimer;
            this.startTimer()
        }
    },
    destroyed() {
        this.stopTimer()
    },
    methods: {
        sendMail: debounce((timer) => {
            if (timer === null) {
                UserApi.sendVerifyMail().then(() => {
                    window.location.reload()
                });
            }
        }, 200),
        startTimer() {
            this.timer = setInterval(() => {
                this.currentTime--
            }, 1000)
        },
        stopTimer() {
            clearTimeout(this.timer)
        },
    },
    watch: {
        currentTime(time) {
            if (time === 0) {
                this.stopTimer()
                this.timer = null;
            }
        }
    },
}
</script>
<template>
    <div class="verify-email">
        <div class="verify-email__header">
            <h2>Подтвердите email</h2>
        </div>
        <div class="verify-email__content">
            <p>Перейдите по ссылке из письма на <b>{{ email }}</b></p>
            <p>Письмо не пришло? Проверьте папку "Спам" или нажмите "<a href="#" class="text-primary" @click.prevent="sendMail(timer)">Отправить письмо еще раз.</a>" <span v-show="timer != null">(повторная отправка возможна через: {{ currentTime }} сек.)</span></p>
            <p>Закройте страницу после подтверждения email</p>
        </div>
    </div>
</template>
